<template>
  <div id="Dashboard">
    <p class="view-title p-l-2">运维中心</p>
    <header class="header">
      <div class="tabs-box clearfix">
        <div class="tab-item" :class="{'active':state==0}" @click="headClick(0)" id="headClick0">
          <span>全部<i>({{datalist.length}})</i></span></div>
        <div class="tab-item" :class="{'active':state==2}" @click="headClick(2)" id="headClick2"><span>正常<i>({{getNum(0)}})</i></span>
        </div>
        <div class="tab-item" :class="{'active':state==1}" @click="headClick(1)" id="headClick1"><span>离线<i>({{getNum(1)}})</i></span>
        </div>
        <div class="tab-item" :class="{'active':state==3}" @click="headClick(3)" id="headClick3"><span>报警<i>({{getNum(2)}})</i></span>
        </div>
      </div>
      <div class="search-input">
        <el-input v-model="searchText" placeholder="请输入公司名称" class="search-input" clearable @keyup.enter.native="searchCompany"></el-input>
        <el-button type="primary" @click="searchCompany">查询</el-button>
      </div>
    </header>
    <div class="list row">
      <sortable v-for="(item, index) in datalist" v-if="showList.includes(item.id)" :options="{animation:500}"
        v-model="dragData" :key="index" :class="{'disabled':item.activeState==2}" :index="index" @sort="isSort=true"
        @sortend="sortend($event, datalist)" replace-direction="horizontal"
        v-show="(state==0||state==item.state||state==3&&item.state==4)&&showCompanyIdArr.includes(item.id)" @click.native="toCompanyConsole(item)">
        <!--  -->
        <!-- <div class="hide-box">
            <p>
              <span class="waring" v-show="item.state==3"></span>
              <span class="normal" v-show="item.state==2"></span>
              <span class="offline" v-show="item.state==1"></span>

              <img :src="imageUrl(item.id)" style="width: 20px; position: relative; bottom: 5px;">
              <span class="company-name">{{item.name}}</span>
            </p>
            <div class="warn-msg">
              <p v-for="warn,w in item.waringMsg" class="waring-p">{{warn}}</p>
            </div>
            <div class="property-lists">
              <p v-for="(property,p) in item.data">
               <span v-if="property.deviceName &&property.type!='date'&&property.type!='text'">{{property.deviceName}}：<span :style="{'color':changeColor(property)}">{{property.type=='bool'||property.type=='enum'?property.specs[property.value]:common.fmoney(property.value,property.step)}} {{property.type=='bool'||property.type=='enum'?'':property.unit}}</span></span>
               <span v-if="property.deviceName &&property.type=='date'">{{property.deviceName}}：<span :style="{'color':changeColor(property)}" style="font-size: 13px;">{{changeTime(property.value)}}</span></span>
               <span v-if="property.deviceName &&property.type=='text'">{{property.deviceName}}：<span :style="{'color':changeColor(property)}">{{property.value}}</span></span>
              </p>
            </div>
            <span class="edit-icon-span" v-if="item.activeState!=2&&!$store.state.isLook"><i><img :ref="'edit'+index" @click.stop="showEdit(item,index)" :src="edit" class="edit-icon" @mouseover="editHover(index)" @mouseout="disHover(index)"></i></span>
          </div> -->
        <div class="list-item clearfix" style="position: relative;">
          <p>
            <span class="error" v-show="item.state==3"></span>
            <span class="normal" v-show="item.state==2"></span>
            <span class="offline" v-show="item.state==1"></span>
            <span class="waring" v-show="item.state==4"></span>
            <span class="company-name">{{item.name}}</span>
          </p>
          <div class="f-l">
            <img :src="imageUrl(item.id)" style="position: relative;text-align: center;" width="80px" height="80px"
              v-default-img="imgErr">
              <!-- <el-image
                    style="width: 80px; height: 80px"
                    :src="'http://iot.yonjie.com'+item.logo"
                    @error="resetLogo(item)"></el-image> -->
          </div>
          <div class="f-r">
            <p v-for="(property,p) in item.data" class="t-hide">
              <span
                v-if="property.deviceName &&property.type!='date'&&property.type!='text'">{{property.deviceName}}：<span
                  :style="{'color':changeColor(property)}" v-if="property.value||property.value==0">{{property.type=='bool'||property.type=='enum'?property.specs[property.value]:common.fmoney(property.value,property.step)}}
                  {{property.type=='bool'||property.type=='enum'?'':property.unit}}</span></span>
              <span v-if="property.deviceName &&property.type=='date'">{{property.deviceName}}：<span
                  :style="{'color':changeColor(property)}"
                  style="font-size: 13px;">{{changeTime(property.value)}}</span></span>
              <span v-if="property.deviceName &&property.type=='text'">{{property.deviceName}}：<span
                  :style="{'color':changeColor(property)}">{{property.value}}</span></span>
            </p>
          </div>
          <span class="edit-icon-span" v-if="item.activeState!=2&&!$store.state.isLook"><i><img :ref="'edit'+index"
                @click.stop="showEdit(item,index)" :src="edit" class="edit-icon" @mouseover="editHover(index)"
                @mouseout="disHover(index)"></i></span>
        </div>
      </sortable>
    </div>
    <div class="popup">
      <div class="popup-delPro" v-show='editShow'>
        <div class="popup-title">
          {{nowObj.name}}-概览设置<i class="el-icon-circle-close close" @click="close" id="close1"></i>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="edit" class="clearfix">
          <div class="popup-lab t-left">
            <p><span class="m-r-180">选择设备：</span><span>选择属性：</span></p>
            <p v-for="item,i in ruleForm.data" :key="i" class="m-b-22">
              <span>设备{{i+1}}：</span>
              <span>
                <el-select v-model="item.deviceCode" placeholder="请选择" @change="changeDev($event,i)">
                  <el-option :key="VirtualDevice.id" label="虚拟设备" :value="VirtualDevice.code">
                  </el-option>
                  <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                  </el-option>
                </el-select>
              </span>
              <span>
                <el-select v-model="item.property" placeholder="请选择" @change="changeVal($event,i)">
                  <el-option v-for="item in item.propertyData" :key="item.id" :label="item.name"
                    :value="item.identifier">
                  </el-option>
                </el-select>
              </span>
              <span class="qk" @click="qk(i)">清空</span>
            </p>
          </div>
          <p class="popup-btn-box">
            <el-button type="primary" id="editBtn" @click="confirm">确定</el-button>
            <el-button @click="close" id="close2">取消</el-button>
          </p>
        </el-form>
      </div>
    </div>
    <div class="mask" v-show="mask"></div>
  </div>
</template>

<script>
  import Sortable from 'vue-drag-sortable'
  export default {
    components: {
      Sortable
    },
    data() {
      return {
        imgErr: require('@/assets/image/company/logo.png'),
        edit: require('@/assets/image/organize/edit.png'),
        edit2: require('@/assets/image/organize/edit2.png'),
        edit4: require('@/assets/image/organize/edit4.png'),
        dragData: {}, //拖动对象
        nowObj: {},
        searchText:"",
        showCompanyIdArr:[],
        nowIndex: null,
        VirtualDevice: {}, //指定企业的虚拟设备
        VirtualFuncList: [], //虚拟设备属性列表
        state: 0,
        list: [],
        showList: [],
        companyList: [],
        editShow: false,
        mask: false,
        deviceList: [],
        isSort: false,
        datalist: [],
        ruleForm: {
          data: [{
              deviceName: null,
              deviceCode: null,
              property: null,
              propertyData: []
            },
            {
              deviceName: null,
              deviceCode: null,
              property: null,
              propertyData: []
            },
            {
              deviceName: null,
              deviceCode: null,
              property: null,
              propertyData: []
            },
            {
              deviceName: null,
              deviceCode: null,
              property: null,
              propertyData: []
            },
            {
              deviceName: null,
              deviceCode: null,
              property: null,
              propertyData: []
            }
          ]
        },
        rules: {

        },
        client: {},
        mqttCodeArr: [], //mqtt主题数组
        offlineNum: 0,
        normalNum: 0,
        warningNum: 0
      };
    },
    watch:{
      searchText:{
        handler(newVal,oldVal){
          if(newVal==""){
            this.showCompanyIdArr=this.datalist.map(item=>item.id)
            return
          }
        },
        immediate:true
      }
    },
    computed: {
      imageUrl() {
        return (id) => {
          for (let item of this.companyList) {
            if (item.id == id) {
              // "http://192.168.3.12"+
              return item.logo
            }
          }
        }
      },
      getNum(){
        return(type)=>{
          let a = 0, b = 0, c = 0
          for (let obj of this.datalist) {
            if (obj.state == 1&&this.showCompanyIdArr.includes(obj.id)) {
              a += 1
            } else if (obj.state == 2&&this.showCompanyIdArr.includes(obj.id)) {
              b += 1
            } else if (obj.state == 3&&this.showCompanyIdArr.includes(obj.id)) {
              c += 1
            } else if (obj.state == 4&&this.showCompanyIdArr.includes(obj.id)) {
              c += 1
            }
          }
          if(type==0){
            return b
          }else if(type==1){
            return a
          }else{
            return c
          }
        }
      }

    },
    created() {
      this.datalist.sort(this.compare('state'))
      this.getDataList()
      this.$store.state.activeIndex = '/Dashboard'
    },
    mounted() {
      this.client = this.$store.state.client
    },
    updated() {
      if (!this.client) {
        this.client = this.$store.state.client
      }
    },
    methods: {
      resetLogo(obj){
        obj.logo = this.imgErr
        // console.log(obj)
      },

      // 清空
      qk(i) {
        let obj = {
          deviceName: null,
          deviceCode: null,
          property: null,
          propertyData: [],
          specs: {},
          step: '',
          type: ''
        }
        this.ruleForm.data[i] = obj
        // console.log(this.ruleForm)
        this.$forceUpdate()
      },
      // mqtt消息监听
      mqttMSG(dev) {
        if (!this.mqttCodeArr.includes(dev.deviceCode)) {
          this.mqttCodeArr.push(dev.deviceCode)
        }
        // 订阅主题
        this.client.subscribe('sys/device/' + dev.deviceCode + '/property/push', {
          qos: 1
        }, (error) => {
          if (!error) {
            // console.log('订阅设备属性主题成功')
          } else {
            // console.log('订阅设备属性主题失败')
          }
        })
        // 接收消息处理
        this.client.on('message', (topic, message) => {
          // console.log('收到来自', topic, '的消息', message.toString())
          // this.msg = message.toString()
          let url = 'sys/device/' + dev.deviceCode + '/property/push' //主题名
          if (topic == url) {
            let obj = message.toString()
            obj = JSON.parse(obj).items
            let arr = [];
            Object.keys(obj).forEach(function(key) { //将items转为键值对象
              let devObj = {};
              devObj.key = key;
              devObj.value = obj[key];
              arr.push(devObj);
            });
            console.log(arr)
            for (let company of this.datalist) { //循环所有企业
              if (company.data.length != 0) { //如果企业关联了设备
                // console.log(arr)
                for (let device of company.data) { //循环企业设备
                  if (device.deviceCode == dev.deviceCode) {
                    for (let val of arr) {
                      if (val.key == device.property) {
                        device.value = val.value
                        this.$forceUpdate()
                      }
                    }
                  }
                }
              }
            }
            // this.$forceUpdate()
          }
        })
        // 链接异常处理
        this.client.on('error', (error) => {
          // console.log('连接失败:', error)
        })
      },
      mqttState() {
        // 接收消息处理
        this.client.on('message', (topic, message) => {
          if (topic.indexOf('sys/company/') != -1) {
            let obj = message.toString()
            if (obj) {
              obj = JSON.parse(obj)
              for (let company of this.datalist) { //循环所有企业
                if (company.id == obj.companyId) {
                  // if (obj.alarm.error != 0) {
                  //   company.state = 3
                  // } else if (obj.alarm.warn != 0) {
                  //   company.state = 4
                  // } else if (obj.online == 'true') {
                  //   company.state = 2
                  // } else {
                  //   company.state = 1
                  // }

                  if(!JSON.parse(obj.online)) {
                  	company.state = 1
                  } else if(obj.alarm.error > 0) {
                  	company.state = 3
                  } else if((obj.alarm.infor > 0) || (obj.alarm.warn > 0)) {
                  	company.state = 4
                  } else {
                  	company.state = 2
                  }
                  // console.log(company,obj)
                }
              }
              // this.datalist = this.clone(this.datalist) //避免修改状态后 对应状态的计数错误
              this.$forceUpdate()
            }
          }
        })
        for (let company of this.datalist) {
          // 订阅主题
          // if(company.id==20||company.id==23){
            // console.log(company.id)
          // }
          this.client.subscribe('sys/company/' + company.id + '/status/push', {
            qos: 1
          }, (error) => {
            if (!error) {
              // console.log('订阅设备属性主题成功')
            } else {
              // console.log('订阅设备属性主题失败')
            }
          })
        }
      },
      // 获取用户配置
      getDataList() {
        this.get('/UserConfig/get', {
          name: 'overview'
        }).then((res) => {
          if (res.success) {
            this.datalist = res.result.value == null || res.result.value == 'null' || res.result.value == '' ? [] :
              JSON.parse(res.result.value)
            for (let item of this.datalist) {
              this.list.push(item.id)
            }
            this.showCompanyIdArr=this.datalist.map(item=>item.id)
            this.getCompany()
          } else {
            this.$message({
              type: 'warning',
              message: `获取列表失败：${res.message}`
            })
          }
        })
      },
      // 获取企业
      getCompany() {
        this.get('/Company/getList').then((res) => {
          if (res.success) {
            this.companyList = this.clone(res.result)
            for (let company of res.result) {
              this.showList.push(company.id)
              if (!this.list.includes(company.id)) {
                let obj = {
                  name: company.shortName,
                  id: company.id,
                  state: 1,
                  createdTime: company.createdTime,
                  waringMsg: [],
                  data: [],
                  activeState: company.state,
                  title: company.title
                }
                this.datalist.push(obj)
              } else {
                for (let item of this.datalist) {
                  if (company.id == item.id) {
                    item.name = company.shortName,
                      item.activeState = company.state,
                      item.id = company.id,
                      item.state = 1,
                      item.title = company.title
                  }
                }
              }
            }
          }
        }).then(() => {
          this.datalist = [...new Map(this.datalist.map(item => [item.id, item])).values()];
          console.log(this.clone(this.datalist))
          this.replaceCompany()
        })
      },
      // 删除不存在的企业
      replaceCompany() {
        let obj = []
        for (let i in this.datalist) {
          if (this.showList.includes(this.datalist[i].id)) {
            obj.push(this.datalist[i])
          }
          if (i == this.datalist.length - 1) {
            this.datalist = obj
            // console.log( this.datalist )
            this.getDeviceVal()
            this.mqttState()
            this.getStep()
          }
        }
        this.showCompanyIdArr=this.datalist.map(item=>item.id)
      },
      // 获取企业设备值
      async getDeviceVal() {
        for (let obj of this.datalist) {
          if (obj.data.length != 0) {
            let arr = []
            for (let dev of obj.data) {
              if (!arr.includes(dev.deviceCode)) { //判断是否请求过
                arr.push(dev.deviceCode)
                if (dev.deviceCode.substring(0, 2) == "_V") { //虚拟设备
                  if (obj.activeState != 2) {
                    this.mqttMSG(dev)
                  }
                  // let result = this.test2(dev.deviceCode);
                  this.get('/VirtualDevice/getPropertyValueByCode', {
                    deviceCode: dev.deviceCode
                  }).then((res) => {
                    if (res.success) {
                      for (let dev2 of obj.data) {
                        let valObj = res.result.filter(item => item.code == dev2.property)[0]
                        if (valObj) {
                          dev2.value = Number(valObj.value)
                        }
                      }
                    }
                  })
                } else {
                  if (obj.activeState != 2) {
                    this.mqttMSG(dev)
                  }
                  // let result = this.test(dev.deviceCode);
                  this.get('/Device/getPropertyValue', {
                    deviceCode: dev.deviceCode
                  }).then((res) => {
                    if (res.success) {
                      for (let a of this.datalist) {
                        if (a.data.length != 0) {
                          for (let b of a.data) {
                            let valObj = res.result.filter(item => item.code == b.property)[0]
                            if (valObj && b.deviceCode == dev.deviceCode) {
                              b.value = b.type != 'text' ? Number(valObj.value) : valObj.value
                            }
                          }
                        }
                      }
                    } else {
                      return []
                    }
                  })

                }
              }
            }
          }
          this.$forceUpdate()
        }
      },
      test(deviceCode) {
        this.get('/Device/getPropertyValue', {
          deviceCode: deviceCode
        }).then((res) => {
          if (res.success) {
            return res.result
          } else {
            return []
          }
        })
        // return new Promise((ret) => {
        //   this.get('/Device/getPropertyValue', {
        //     deviceCode: deviceCode
        //   }).then((res) => {
        //     if (res.success) {
        //       ret(res.result)
        //     } else {
        //       ret([])
        //     }
        //   })
        // })
      },
      test2(deviceCode) {
        this.get('/VirtualDevice/getPropertyValueByCode', {
          deviceCode: deviceCode
        }).then((res) => {
          if (res.success) {
            return res.result
          } else {
            return []
          }
        })
        // return new Promise((ret) => {
        //   this.get('/VirtualDevice/getPropertyValueByCode', {
        //     deviceCode: deviceCode
        //   }).then((res) => {
        //     if (res.success) {
        //       ret(res.result)
        //     }
        //   })
        // })
      },
      // 获取企业关联设备的步长
      getStep() {
        for (let com of this.datalist) {
          if (com.data.length != 0 && com.activeState != 2) {
            let codeArr = []
            for (let dev of com.data) {
              if (dev.deviceCode.substring(0, 2) != "_V" && !codeArr.includes(dev.deviceCode)) { //非虚拟设备
                codeArr.push(dev.deviceCode)
                this.get('/ProductFeature/getByDeviceCode', {
                  code: dev.deviceCode
                }).then((res) => {
                  if (res.success) {
                    let attrData = res.result == "" ? [] : JSON.parse(res.result).properties //属性数组
                    for (let a of attrData) {
                      for (let b of com.data) {
                        if (a.identifier == b.property) {
                          b.deviceName = a.name
                          b.step = a.dataType.specs.step
                          b.type = a.dataType.type
                          if (a.dataType.type == 'bool' || a.dataType.type == 'enum') {
                            b.specs = a.dataType.specs
                          } else {
                            b.specs = {}
                          }
                        }
                      }
                    }
                  }
                })
              } else if (dev.deviceCode.substring(0, 2) == "_V" && !codeArr.includes(dev.deviceCode)&& (dev.VirtualDeviceId||dev.VirtualDeviceId==0)) {
                let sendObj = {
                  companyId: com.id,
                  deviceId: dev.VirtualDeviceId
                }
                // debugger
                this.get('/VirtualDevice/getPropertyList', sendObj).then(res => {
                  if (res.success) {
                    let com1 = this.datalist.filter(item => item.id==com.id)[0]
                    if(com1.id == com.id){
                      for (let a of res.result) {
                        for (let b of com1.data) {
                          if (a.code == b.property) {
                            b.deviceName = a.name
                            b.step =  1
                            b.unit = a.unit||''
                          }
                        }
                      }
                    }
                  }
                })
              }
            }
          }
          // console.log(this.datalist)
        this.$forceUpdate()
        }
      },
      //获取指定企业的虚拟设备
      getVirtualDevice(id) {
        let parm = {
          companyId: id
        }
        this.get('/VirtualDevice/get', parm).then((res) => {
          if (res.success) {
            this.VirtualDevice = res.result
            this.getVirtualFuncList(id)
          } else {
            this.$message({
              message: `获取企业虚拟设备失败：${res.message}`,
              type: "warning"
            })
          }
        })
      },
      //获取虚拟设备的属性列表
      getVirtualFuncList(id) {
		if(!this.VirtualDevice.id&&this.VirtualDevice.id!=0){ return }
        let parm = {
          deviceId: this.VirtualDevice.id,
          companyId: id
        }
        this.get('/VirtualDevice/getPropertyList', parm).then((res) => {
          if (res.success) {
            for (let obj of res.result) {
              obj.dataType = {
                type: 'double',
                specs: []
              }
              obj.identifier = obj.code
            }
            this.VirtualFuncList = res.result
            for (let i in this.nowObj.data) {
              if (this.nowObj.data[i].deviceCode) {
                let obj = {
                  deviceName: this.nowObj.data[i].deviceName,
                  deviceCode: this.nowObj.data[i].deviceCode,
                  property: this.nowObj.data[i].property,
                  type: this.nowObj.data[i].type,
                  propertyData: [],
                  specs: this.nowObj.data[i].specs,
                  step: this.nowObj.data[i].step,
                  unit: this.nowObj.data[i].unit,
                }
                this.$set(this.ruleForm.data, i, obj)
                this.changeDev(obj.deviceCode, i, true)
              } else {
                this.nowObj.data[i] = {
                  deviceName: null,
                  deviceCode: null,
                  property: null,
                  propertyData: []
                }
              }
            }
            setTimeout(() => {
              this.mask = true
              this.editShow = true;
            }, 200)
            // console.log(this.VirtualFuncList)
          } else {
            this.$message({
              message: `获取企业虚拟设备数据失败：${res.message}`,
              type: "warning"
            })
          }
        })
      },
      // 修改图标hover
      editHover(i) {
        let img = 'edit' + i
        if (this.cssType == 0) {
          this.$refs[img][0].src = this.edit2
        } else if (this.cssType == 1) {
          this.$refs[img][0].src = this.edit4
        }
      },
      // 修改图标还原
      disHover(i) {
        let img = 'edit' + i
        this.$refs[img][0].src = this.edit
      },
      // 修改弹窗
      showEdit(item, i) {
        // console.log("id",item.id)
        this.nowObj = item;
        this.nowIndex = i;
        this.get('/Device/getList', {
          companyId: item.id
        }).then((res) => { //获取设备列表
          if (res.success) {
            this.deviceList = res.result
            this.getVirtualDevice(item.id)
          } else {
            this.$message({
              message: `获取企业设备数据失败：${res.message}`,
              type: "warning"
            })
          }
        })
      },
      // 关闭弹窗
      close() {
        this.mask = false;
        this.editShow = false;
        this.ruleForm = this.$options.data().ruleForm
      },
      // 头部点击
      headClick(i) {
        this.state = i
      },
      // 模糊匹配公司
      searchCompany(){
        if(this.searchText==""){
          this.showCompanyIdArr=this.datalist.map(item=>item.id)
          return
        }
        var showList = this.datalist.filter(i => i.name.indexOf(this.searchText)!=-1||i.title.indexOf(this.searchText)!=-1)
        this.showCompanyIdArr = showList.map(i=>i.id)
        // console.log(this.datalist,this.showCompanyIdArr)
      },
      // 状态排序
      compare(property) {
        return function(a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value2 - value1;
        }
      },
      // 跳转运维中心
      async toCompanyConsole(item) {
        if (!this.$store.state.functionList.includes('companyServiceView') || item.activeState == 2) {
          return
        }
        if (this.isSort) {
          this.isSort = false
          return
        }
        if (item.createdTime) {
          this.$store.state.companyCreatedTime = item.createdTime
        }
        let company = this.companyList.filter(i => i.id == item.id)[0]
        // this.get('/Company/get',{id:item.id}).then(res=>{
        //   if(res.success){
        //     company = res.result
        //   }
        // })
        await this.get('/UserConfig/get',{name:'mute'}).then((res)=>{
            if(res.success){
              this.$store.state.userConfig.mute=res.result.value?Number(res.result.value):0
              localStorage.setItem('mute',this.$store.state.userConfig.mute)
            }
        })
        let energyShow = false,ScreenPage=false
        this.$store.state.companyIndexPreviewUrl="/CompanyConsole/IndexEditShow"
        await this.get('/Screen/getHomepage',{companyId:item.id,type:1}).then(res=>{
          if(res.success){
            if(res.success&&res.result.id){
              ScreenPage = true
              this.$store.state.companyIndexPreviewUrl = "/CompanyConsole/indexPreview?type=1&id="+res.result.id
            }
          }
        })
        if(company&&company.module){
          if(company.module.indexOf('Energy')!=-1){
            energyShow = true
          }
        }
        let homepage = localStorage.getItem('homepage')
        // 没有能源管理方案,或者有应用大屏时修改配置路径
        if(homepage=="/Energy/index"&&energyShow){
          this.$store.state.userConfig.homepage="/Energy/index"
        }else{
          homepage = this.$store.state.companyIndexPreviewUrl
        }

        // console.log(this.$store.state.companyIndexPreviewUrl,homepage)
        // 更新vuex路径
        if (homepage != this.$store.state.userConfig.homepage) {
          this.$store.state.userConfig.homepage = homepage
        }

        this.$store.state.energyShow = energyShow
        this.$store.state.companyCode = company.code
        let state = JSON.stringify(this.$store.state)
        //sessionStorage改为localstorage
        // sessionStorage.setItem("store", state)
        // sessionStorage.setItem('companyId', item.id)
        localStorage.setItem("store", state)
        localStorage.setItem('companyId', item.id)
        sessionStorage.setItem("store", state)
        sessionStorage.setItem('companyId', item.id)
        clearInterval(this.timeInterval)
        this.windowOpen(this.$store.state.userConfig.homepage, item.id,null,item.title)
        // if(this.$store.state.userConfig.homepage =='/Energy/index'){
        //   this.windowOpen('/Energy/index',item.id)
        // }else{
        // }
      },
      // 修改设备
      changeDev(val, i, isSet) {
        // console.log(val,i)
        if (!isSet) {
          this.ruleForm.data[i].property = null
        }
        if (val == this.VirtualDevice.code) {
          this.ruleForm.data[i].propertyData = this.VirtualFuncList
        } else {
          // console.log('device')
          this.get('/ProductFeature/getByDeviceCode', {
            code: val
          }).then((res) => {
            if (res.success) {
              let attrData = res.result == "" ? [] : JSON.parse(res.result).properties //属性数组
              let propertyArr; //设备关联属性数组
              for (let devObj of this.deviceList) {
                if (devObj.code == val) {
                  propertyArr = devObj.propertySet.split(',') //设备关联属性数组
                }
              }
              let arr = []
              for (let attrObj of attrData) {
                for (let property of propertyArr) {
                  if (property == attrObj.identifier) {
                    arr.push(attrObj)
                  }
                }
              }
              this.ruleForm.data[i].propertyData = arr
            } else {
              this.$message({
                type: 'warning',
                message: `获取设备属性失败：${res.message}`
              })
            }
          })
        }
      },
      // 修改设备属性
      changeVal(val, i) {
        for (let obj of this.ruleForm.data[i].propertyData) {
          if (obj.identifier == val) {
            this.ruleForm.data[i].deviceName = obj.name;
            this.ruleForm.data[i].type = obj.dataType.type;
            this.ruleForm.data[i].step = obj.dataType.specs ? obj.dataType.specs.step : ''
            if (obj.function && obj.step) {
              this.ruleForm.data[i].step = obj.step;
            }
            if (obj.dataType.type == 'int' || obj.dataType.type == 'float' || obj.dataType.type == 'double') {
              this.ruleForm.data[i].unit = obj.dataType.specs.unit;
            } else if (obj.dataType.type == 'bool' || obj.dataType.type == 'enum') {
              this.ruleForm.data[i].specs = obj.dataType.specs
            }
            if (obj.dataType.errorDown) {
              this.ruleForm.data[i].errorDown = obj.dataType.errorDown;
            }
            if (obj.dataType.errorUp) {
              this.ruleForm.data[i].errorUp = obj.dataType.errorUp;
            }
            if (obj.dataType.warnDown) {
              this.ruleForm.data[i].warnDown = obj.dataType.warnDown;
            }
            if (obj.dataType.warnUp) {
              this.ruleForm.data[i].warnUp = obj.dataType.warnUp;
            }
          }
        }
      },
      //修改企业关联属性
      confirm() {
        let DataList = this.clone(this.datalist) //克隆列表数据
        DataList[this.nowIndex].data = this.clone(this.ruleForm.data); //设置修改对象的属性
        // console.log(this.ruleForm.data)
        let parm = []
        for (let item of DataList) {
          let obj = {
            id: item.id,
            createdTime: item.createdTime,
            name: item.name,
            state: item.state,
            data: []
          };
          if (item.data.length != 0) { //如果企业有关联设备属性
            for (let attr of item.data) {
              if (attr.deviceCode && attr.deviceName && attr.property) { //检查是否设置完整
                let data = {
                  deviceCode: attr.deviceCode,
                  // deviceCode:attr.deviceCode,
                  deviceName: attr.deviceName,
                  property: attr.property,
                  unit: attr.unit,
                  type: attr.type,
                  step: attr.step,
                  specs: attr.specs
                }
                if (attr.deviceCode.substring(0, 2) == "_V") {
                  data.VirtualDeviceId = this.VirtualDevice.id
                }
                if (!data.unit && attr.propertyData) {
                  for (let k of attr.propertyData) {
                    if (data.property == k.identifier) {
                      data.unit = k.dataType.specs.unit
                    }
                  }
                }
                if (attr.errorDown) {
                  data.errorDown = attr.errorDown;
                }
                if (attr.errorUp) {
                  data.errorUp = attr.errorUp;
                }
                if (attr.warnDown) {
                  data.warnDown = attr.warnDown;
                }
                if (attr.warnUp) {
                  data.warnUp = attr.warnUp;
                }
                obj.data.push(data)
              }
            }
          }
          parm.push(obj)
        }
        this.postNoJson('/UserConfig/set', {
          name: 'overview',
          value: parm
        }).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: `修改成功`
            })
            // console.log(this.nowObj.data,parm[this.nowIndex],this.ruleForm.data)
            this.datalist = parm //修改页面列表
            this.getDeviceVal()
            this.close()
            this.$forceUpdate()
          } else {
            this.$message({
              type: 'warning',
              message: `修改失败：${res.message}`
            })
          }
        })
      },
      // 修改颜色
      changeColor(obj) {
        if (!obj.value || obj.type == 'enum' || obj.type == 'bool') {
          return
        }
        let value = obj.value
        let color = "#2c3e50"
        if (obj.warnUp) {
          if (value >= Number(obj.warnUp)) {
            color = '#ff7e00'
          }
        }
        if (obj.warnDown) {
          if (value <= Number(obj.warnDown)) {
            color = '#ff7e00'
          }
        }
        if (obj.errorUp) {
          if (value >= Number(obj.errorUp)) {
            color = '#ff0000'
          }
        }
        if (obj.errorDown) {
          if (value <= Number(obj.errorDown)) {
            color = '#ff0000'
          }
        }
        return color
      },
      // 组件方法
      click(e) {
        if (e.currentTarget.__preventClick) {
          delete e.currentTarget.__preventClick;
          return;
        }
      },
      sort(e) {
        const {
          oldIndex,
          newIndex
        } = e;
      },
      sortend(e, list) {
        let data = this.clone(list)
        const {
          oldIndex,
          newIndex
        } = e;
        if (oldIndex > newIndex) {
          data.splice(newIndex, 0, data[oldIndex]);
          data.splice(oldIndex + 1, 1);
        } else {
          data.splice(newIndex + 1, 0, data[oldIndex]);
          data.splice(oldIndex, 1);
        }
        this.isSort = false;
        let parm = []
        for (let item of data) {
          let obj = {
            id: item.id,
            createdTime: item.createdTime,
            name: item.name,
            state: item.state,
            data: []
          };
          if (item.data.length != 0) { //如果企业有关联设备属性
            for (let attr of item.data) {
              if (attr.deviceCode && attr.deviceName && attr.property) { //检查是否设置完整
                let data = {
                  deviceCode: attr.deviceCode,
                  deviceName: attr.deviceName,
                  property: attr.property,
                  unit: attr.unit,
                  type: attr.type,
                  step: attr.step,
                  specs: attr.specs || []
                }
                obj.data.push(data)
              }
            }
          }
          parm.push(obj)
        }
        this.postNoJson('/UserConfig/set', {
          name: 'overview',
          value: parm
        }).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: `修改成功`
            })
            const {
              oldIndex,
              newIndex
            } = e;
            this.rearrange(list, oldIndex, newIndex);
            // this.getDevice()
          } else {
            this.$message({
              type: 'warning',
              message: `修改失败：${res.message}`
            })
          }
        })
      },
      rearrange(array, oldIndex, newIndex) {
        if (oldIndex > newIndex) {
          array.splice(newIndex, 0, array[oldIndex]);
          array.splice(oldIndex + 1, 1);
        } else {
          array.splice(newIndex + 1, 0, array[oldIndex]);
          array.splice(oldIndex, 1);
        }
      },
    },
    beforeDestroy() {
      for (let code of this.mqttCodeArr) {
        let options = {
          onSuccess() {
            // console.log("退订成功")
          },
          onFailure(error) {
            // console.log("退订失败")
          }
        }
        let url = 'sys/device/' + code + '/property/push'
        // console.log('我要退订',url)
        this.client.unsubscribe(url, options)
      }
      for (let company of this.datalist) {
        let options = {
          onSuccess() {
            // console.log("退订成功")
          },
          onFailure(error) {
            // console.log("退订失败")
          }
        }
        let url = 'sys/company/' + company.id + '/status/push' //主题名
        // console.log('我要退订',url)
        this.client.unsubscribe(url, options)
      }
    },
  }
</script>

<style scoped>
  .qk {
    margin-left: 12px;
    color: #5087e4;
    cursor: pointer;
  }

  #Dashboard {
    text-align: left;
    padding: 0 18px;
    max-height: 100%;
    overflow-x: auto;
  }

  .list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 18px;
    padding-left: 0;
    min-height: 241px;
  }

  .list>* {
    float: left;
    /* width: 224px; */
    border-radius: 5px;
    margin-bottom: 16px;
    margin-right: 16px;
    box-sizing: border-box;
    height: 170px;
    background-color: #fff;
    padding: 16px 14px;
    width: 329px;
    font-size: 14px;
  }

  .list>.dragging {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .2);
  }

  .list.row>* {
    display: inline-block;
    border: 1px solid #dcdcdc;
  }

  .list-item {
    width: 313px;
    background-color: #fff;
  }

  .list-item>p {
    margin-right: 14px;
    border-bottom: 1px solid #ccc;
  }

  .list-item .f-l {
    width: 80px;
    height: 80px;
    margin-top: 15px;
    text-align: center;
  }

  .list-item .f-r {
    width: 200px;
  }

  .waring,
  .normal,
  .offline,
  .error {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-left: 5px;
    border-radius: 50%;
    margin-right: 10px;
    box-sizing: border-box;
    margin-bottom: 5px;
  }

  .error {
    background-color: #ff4040;
    box-shadow: 0 0 5px 1px #ff4040;
  }

  .waring {
    background-color: #ffd200;
    box-shadow: 0 0 5px 1px #ffd200;
  }

  .normal {
    background-color: #40ffcb;
    box-shadow: 0 0 5px 1px #40ffcb;
  }

  .offline {
    background-color: #c4c4c4;
    box-shadow: 0 0 5px 1px #c4c4c4;
  }
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 14px;
  }
  .search-input{
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .tabs-box {
    text-align: center;
    width: 443px;
    height: 40px;
    overflow: hidden;
    background-color: #fff;
    border-radius: 5px;
    display: flex;
    justify-items: space-between;
    align-items: center;
  }

  .tabs-box .tab-item {
    float: left;
    padding: 9px 0;
  }

  .tabs-box span {
    display: inline-block;
    width: 110px;
    font-size: 14px;
    line-height: 22px;
    border-left: 1px solid #e2e2e2;
    cursor: pointer;
    float: left;
  }

  .tabs-box>div:first-child span {
    border: none;
  }

  .active {
    background: #5087e4;
    color: #fff;
  }

  .active>span {
    border: 0;
  }

  .company-name {
    display: inline-block;
    width: 68%;
    line-height: 24px;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .property-lists {
    font-size: 14px;
    width: 200px;
    line-height: 34px;
  }

  .property-lists>p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .t-hide {
    line-height: 23.5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .wrapper>span {
    display: flex;
    width: 100%;
    align-content: space-between;
    align-items: baseline;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 14px 44px 0 18px;
  }

  .disabled {
    color: #c4c4c4 !important;
    cursor: not-allowed !important;
  }

  .disabled .hide-box {
    cursor: not-allowed !important;
  }

  .disabled .property-lists span {
    color: #c4c4c4 !important;
  }

  .item {
    height: 100%;
    overflow: hidden;
  }

  .hide-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }

  .waring-p {
    font-size: 14px;
    line-height: 34px;
    color: #ff4040;
  }

  .edit-icon-span {
    position: absolute;
    top: 0;
    right: 12px;
    z-index: 1;
  }

  .edit-icon {
    width: 16px;
  }

  .mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index: 6;
  }

  /* 弹窗 */
  .popup>div {
    position: fixed !important;
    top: 15%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -290px;
    width: 597px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 30px;
    height: 505px;
    text-align: left;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 12px;
    text-align: left;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px;
  }

  .popup-btn-box {
    text-align: center;
    margin-top: 30px;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 38px;
  }

  .popup-btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 20px;
  }

  .b-32 {
    position: absolute;
    bottom: 32px;
    left: 0;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .m-r-180 {
    margin-right: 180px;
  }

  .m-b-22 {
    margin-bottom: 22px;
  }

  .p-l-2 {
    padding-left: 2px !important;
  }
</style>
<style>
  #Dashboard .el-input__icon {
    line-height: 34px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue